import {
  CError,
} from '../consoleMixin'
import {
  getAxiosClient,
} from './axios-client'
import {
  buildQueryFilter,
  buildSortParams,
} from './helpers'

/**
 * @typedef {import('./js-doc').V2CreateReserveRequest} CreateReserveRequest
 * @typedef {import('./js-doc').V2ReserveResponse} V2ReserveResponse
 * @typedef {import('./js-doc').V2ReserveTotalResponse} V2ReserveTotalResponse
 * @typedef {import('./js-doc').V2DeleteReserveRequest} V2DeleteReserveRequest
 */

class Reserve {
  constructor (clientId) {
    this.baseURL = `clients/${clientId}/reserves`
  }

  /**
   * Create a reserve for the client specified in the constructor
   * @param {CreateReserveRequest} requestBody - V1 reserve request body
   * @returns {Promise<V2ReserveResponse>} - V2 response body
   */
  async create (requestBody) {
    try {
      const result = (await (await getAxiosClient(this.baseURL)).post(``, requestBody))
      return result?.data
    }
    catch (error) {
      CError('Could not create reserve in V2 API', error)
      throw error
    }
  }

  /**
   * Obtail the total for a client
   * @returns {Promise<V2ReserveTotalResponse>} - V2 response body
   */
  async total () {
    try {
      const result = (await (await getAxiosClient(this.baseURL)).get('total'))
      return result?.data
    }
    catch (error) {
      CError(`Could not obtain reserves total from V2 API`, error)
      throw error
    }
  }

  // eslint-disable-next-line no-unused-vars
  async list (filterParams, sortParams, paginationParams) {
    const filter = buildQueryFilter(filterParams)
    const sort = buildSortParams(sortParams)

    try {
      return await (await getAxiosClient(this.baseURL)).get('', {
        params: {
          filter,
          limit: paginationParams.limit,
          page: paginationParams.page,
          sort,
        },
      })
    }
    catch (error) {
      CError(`Could not list reserves from V2 API`, error)
      throw error
    }
  }

  /**
   * @param {string} id - ID of the reserve
   * @param {V2DeleteReserveRequest} payload - V2 reserve delete request body
   * @returns {Promise<V2ReserveResponse>} - V2 response body
   */
  async delete (id, payload) {
    try {
      const result = await (await getAxiosClient(this.baseURL)).delete(id, { data: payload })
      return result?.data
    }
    catch (error) {
      CError(`Could not delete reserve with ${id} from V2 API`, error)
      throw error
    }
  } 
}

export default Reserve
